export function* simpleIdGenerator(prefix) {
    let index = 0;
    while (true) {
        yield `${prefix}-${index++}`;
    }
}
